import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

export default window.customElements.define(
  'header-nav',
  class extends CustomElement {
    constructor() {
      super()

      this._onHeaderUpdate = this.onHeaderUpdate.bind(this)
      this._onTransitionLeave = this.onTransitionLeave.bind(this)
      this._showCurrent = this.showCurrent.bind(this)
      this._onResize = this.onResize.bind(this)

      this.events = {
        ...this.events,
        mouseenter: 'onMouseenter',
        'mouseenter .js-panel': 'onMouseenterPanel',
        'mouseenter .js-header-nav-cursor-target': 'onMouseenterCursorTarget',
        mouseleave: 'onMouseleave',
        'click a': 'onClickLink'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      this.$currentEl = this.querySelector('.js-header-nav-current')
      this.$bar = this.querySelector('.js-header-nav-bar')
      this.$cursor = this.querySelector('.js-header-nav-cursor')
      this.$cursorTargets = this.querySelectorAll(
        '.js-header-nav-cursor-target'
      )

      Emitter.on('header-nav:update', this._onHeaderUpdate)
      Emitter.on('transition:leave', this._onTransitionLeave)
      Emitter.on('resize', this._onResize)

      this.onResize()
      this.moveCursorToActive()
      setTimeout(this._showCurrent, 300)
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      Emitter.off('header-nav:update', this._onHeaderUpdate)
      Emitter.off('resize', this._onResize)
    }

    onResize() {
      this.barBounds = this.$bar.getBoundingClientRect()
    }

    open() {
      this.classList.add('is-active')
      this.setData({ 'open-panel': false })
    }

    close() {
      this.classList.remove('is-active')
    }

    showCurrent() {
      const { current } = this.dataset
      if (current) {
        this.$currentEl.textContent = current
        setTimeout(() => {
          this.classList.add('has-current')
        }, 10)
      }
    }

    hideCurrent() {
      this.classList.remove('has-current')
    }

    onHeaderUpdate({ nextCurrentMenu: current }) {
      this.hideCurrent()
      this.moveCursorToActive()

      setTimeout(() => {
        this.setData({ current })
        this._showCurrent()
      }, 300)
    }

    onTransitionLeave() {
      this.hideCurrent()
    }

    onMouseenter() {
      this.open()
    }

    onMouseleave() {
      this.close()
    }

    onMouseenterPanel() {
      this.setData({ 'open-panel': true })
    }

    onClickLink() {
      this.close()
    }

    onMouseenterCursorTarget(e) {
      this.moveCursor(e.target)
    }

    moveCursorToActive() {
      const active = Array.from(this.$cursorTargets).find((el) =>
        el.classList.contains('is-active')
      )
      if (active) this.moveCursor(active)
    }

    moveCursor(element) {
      const { left, width } = element.parentElement.getBoundingClientRect()
      this.$cursor.style.transform = `translate3d(${
        left - this.barBounds.left
      }px, 0, 0)`
      this.$cursor.style.width = `${width}px`
    }
  }
)
